import React from 'react';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import './app-time-picker.scss';

interface AppTimePickerProps {
  value?: string | null;
  onChange?: (newTime: string | null) => void;
  placeholder?: string;
  disabled?: boolean;
}

const AppTimePicker: React.FC<AppTimePickerProps> = ({
  value = null,
  onChange,
  placeholder,
  disabled = false
}) => {
  return (
    <div className="app-time-picker-container">
      <TimePicker
        value={value || '00:00'}
        onChange={(newValue) => {
          if (onChange) {
            try {
              onChange(newValue ?? '00:00');
            } catch (e) {

            }
          }
        }}
        maxTime='23:59'
        minTime='00:00'
        format="HH:mm"
        disableClock={true}
        clearIcon={null}
        clockIcon={null}
        disabled={disabled}
        className="app-time-picker"
        required={!disabled}
      />
    </div>
  );
};

export default AppTimePicker;
